import type { Theme } from "@mui/material";

declare module "@mui/material/Chip" {
  interface ChipPropsSizeOverrides {
    xsmall: true;
  }
}

export default function getChipOverrides(theme: Theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "24px",
          padding: 0,
          minHeight: 0,
          height: 20,
        },
        sizeSmall: {
          fontSize: "10px",
          fontWeight: 500,
          padding: "0 2px",
          minHeight: 0,
          height: 20,
          "& .MuiSvgIcon-root": {
            fontSize: 10,
            marginLeft: 2,
            marginRight: 0,
          },
        },
        label: {
          paddingLeft: 4,
          paddingRight: 4,
          paddingTop: 0,
          paddingBottom: 0,
          lineHeight: 1.2,
        },
        colorDefault: {
          backgroundColor: "#000",
          color: "#fff",
        },
      },
    },
  };
}
